export const SET_LANGUAGE = "SET_LANGUAGE";

export const setLanugage = (language) => ({
    type: SET_LANGUAGE,
    payload: language,
});
